module.exports = __webpack_public_path__ + "../resources/images/letsgo-cloud-west-1a4e7c14f432c1836422c9dc19a581ae.png";